import AccessibleAlert from './AccessibleAlert';

export default AccessibleAlert;
